import { Link, useLocation } from "react-router-dom";
import { Home, Radio, ShoppingBag, Briefcase, LayoutGrid } from "lucide-react";
import { Logo, Wordmark } from "./Logo";
import { useAuth, ROLE_HOME } from "../context/AuthContext";
import { DIVISIONS } from "../lib/heritage";
import { MegaMenu } from "./MegaMenu";
import { HeaderDial } from "./public/HeaderDial";

const LINKS = [["/history", "History"], ["/organisation", "Organisation"], ["/hub", "Live Hub"], ["/shop", "Shop"], ["/careers", "Careers"]];
const TABS = [["/", Home, "Home"], ["/hub", Radio, "Live"], ["/shop", ShoppingBag, "Shop"], ["/careers", Briefcase, "Careers"], ["/login", LayoutGrid, "Portal"]];

const BottomTabs = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-xl border-t border-[color:var(--line)] grid grid-cols-5 pb-[env(safe-area-inset-bottom)] no-print" data-testid="bottom-tabs">
      {TABS.map(([to, I, l]) => {
        const href = l === "Portal" && user ? ROLE_HOME[user.role] : to;
        const on = to === "/" ? pathname === "/" : pathname.startsWith(to);
        return (
          <Link key={l} to={href} className={`flex flex-col items-center gap-0.5 py-2 text-[10px] font-semibold transition-colors ${on ? "text-brand-green" : "text-slate-500"}`} data-testid={`tab-${l.toLowerCase()}`}>
            <span className={`w-9 h-7 rounded-full flex items-center justify-center ${on ? "bg-brand-green" : ""}`}><I size={18} className={on ? "text-white" : ""} /></span>{l}
          </Link>
        );
      })}
    </nav>
  );
};

export const PublicHeader = ({ onFeedback }) => {
  const { user } = useAuth();
  return (
    <>
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-[color:var(--line)] no-print">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between gap-2 sm:gap-4">
        <Link to="/" data-testid="dgc-logo-home" className="shrink-0"><span className="hidden sm:block"><Logo size={46} /></span><span className="sm:hidden"><Logo size={38} /></span></Link>
        <nav className="hidden lg:flex items-center gap-7 text-sm text-slate-300">
          {LINKS.map(([h, l]) => (
            h.includes("#")
              ? <a key={h} href={h} className="hover:text-brand-green transition-colors" data-testid={`nav-${l.toLowerCase().replace(" ", "-")}`}>{l}</a>
              : <Link key={h} to={h} className="hover:text-brand-green transition-colors" data-testid={`nav-${l.toLowerCase().replace(" ", "-")}`}>{l}</Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <HeaderDial />
          {onFeedback && <button onClick={onFeedback} className="btn-ghost hidden md:inline-flex" data-testid="header-feedback-btn">Feedback</button>}
          <Link to={user ? ROLE_HOME[user.role] : "/login"} className="btn-gold whitespace-nowrap hidden sm:inline-flex" data-testid="header-portal-btn">{user ? "My Portal" : "Staff Login"}</Link>
          <MegaMenu />
        </div>
      </div>
      <div className="kente opacity-70" />
    </header>
    <BottomTabs />
    </>
  );
};

export const Footer = () => (
  <footer className="border-t border-[color:var(--line)] mt-24 pb-16 lg:pb-0 no-print" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid md:grid-cols-3 gap-10 text-sm text-slate-400">
      <div><Logo size={52} /><p className="mt-4 max-w-xs">Founded 1997 by Dr. Osei Kwame Despite. The living intelligence & operations layer of the Despite Group of Companies.</p></div>
      <div>
        <div className="eyebrow mb-3">Group</div>
        <p className="flex flex-wrap gap-x-3 gap-y-1">{DIVISIONS.flatMap((d) => d.items).map(([n, , , s]) => <Link key={s} to={`/entities/${s}`} className="hover:text-brand-green" data-testid={`footer-link-${s}`}>{n}</Link>)}</p>
      </div>
      <div>
        <div className="eyebrow mb-3">Data integrity</div>
        <p>News is scraped live from Peacefmonline.com with source links. Anything not from a public source is labelled <span className="text-amber-300">Sample data</span>. Twi sentiment requires validation by Twi speakers.</p>
      </div>
    </div>
    <div className="text-center font-data text-[10px] tracking-[0.3em] text-slate-600 pb-8">© 2026 DESPITE GROUP OF COMPANIES · DGC WPA</div>
  </footer>
);
